import React from 'react';

/**
 * SkeletonLoader
 * Animated shimmer placeholders for data-loading states.
 * Variants: 'kpi' | 'table' | 'chart' | 'card'
 */

export const SkeletonKpi = ({ count = 4 }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
      gap: '16px',
    }}
  >
    {Array.from({ length: count })?.map((_, i) => (
      <div key={i} className="skeleton skeleton-kpi" />
    ))}
  </div>
);

export const SkeletonTableRows = ({ rows = 6, cols = 5 }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
    {Array.from({ length: rows })?.map((_, i) => (
      <div key={i} style={{ display: 'flex', gap: '8px', padding: '8px 0' }}>
        {Array.from({ length: cols })?.map((_, j) => (
          <div
            key={j}
            className="skeleton"
            style={{
              height: '20px',
              flex: j === 0 ? '0 0 40px' : j === cols - 1 ? '0 0 80px' : '1',
              borderRadius: '4px',
            }}
          />
        ))}
      </div>
    ))}
  </div>
);

export const SkeletonChart = () => (
  <div className="skeleton skeleton-chart" />
);

export const SkeletonCard = ({ height = 120 }) => (
  <div
    className="skeleton"
    style={{ height, borderRadius: 'var(--radius-lg)' }}
  />
);

const SkeletonLoader = ({ variant = 'card', ...props }) => {
  switch (variant) {
    case 'kpi':   return <SkeletonKpi {...props} />;
    case 'table': return <SkeletonTableRows {...props} />;
    case 'chart': return <SkeletonChart {...props} />;
    default:      return <SkeletonCard {...props} />;
  }
};

export default SkeletonLoader;
